import { FileText } from "lucide-react";

const TYPE_LABELS = { devis: "Devis", proforma: "Proforma", commande: "Commande", facture: "Facture", avoir: "Avoir" };
const STATUS_LABELS = { brouillon: "Brouillon", envoye: "Envoyé", envoyee: "Envoyée", accepte: "Accepté", "acompté": "Acompté", "soldé": "Soldé", refuse: "Refusé", expire: "Expiré", confirmee: "Confirmée", en_cours: "En cours", livree: "Livrée", annulee: "Annulée", payee: "Payée", en_retard: "En retard", emis: "Émis", applique: "Appliqué", validee: "Validée", archivee: "Archivée" };
const formatEur = (v) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);
const formatDate = (d) => (d ? new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString("fr-FR") : "");

/** Groupe « Documents » de la recherche globale : trouvé par numéro, ouvre le document au clic. */
export const DocumentResults = ({ documents, onOpen }) => {
  if (!documents?.length) return null;
  return (
    <div>
      <div className="px-3 py-1.5 text-[10px] font-semibold text-slate-500 uppercase tracking-wider bg-slate-900/50">Documents</div>
      {documents.map((d) => (
        <button
          key={d.id}
          onClick={() => onOpen(d)}
          className="w-full flex items-center gap-3 px-3 py-2 hover:bg-slate-700/50 transition-colors text-left"
          data-testid={`search-result-document-${d.id}`}
        >
          <div className="w-7 h-7 rounded-md bg-emerald-600/20 flex items-center justify-center shrink-0">
            <FileText size={13} className="text-emerald-400" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-white truncate">
              <span className="text-slate-400">{TYPE_LABELS[d.type] || d.type}</span> <span className="font-mono">{d.number}</span>
              <span className="float-right text-xs text-slate-300">{formatEur(d.total_ttc)}</span>
            </p>
            <p className="text-[10px] text-slate-500 truncate">
              {d.client_name || "-"} - {formatDate(d.date)} - {STATUS_LABELS[d.status] || d.status}
            </p>
          </div>
        </button>
      ))}
    </div>
  );
};
